/* eslint-disable react/display-name */
import React from 'react';
import DatePicker from 'react-datepicker';
import PropType from 'prop-types';

import 'react-datepicker/dist/react-datepicker.css';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { InputAdornment } from '@mui/material';
import NInput from './NInput';

const DatePickerInput = React.forwardRef((Iprops, ref) => (
  <NInput
    autoComplete='off'
    placeholder={Iprops?.InputPlaceholder}
    label={Iprops?.label}
    value={Iprops?.value}
    className='w-full bg-white !py-0'
    onClick={Iprops?.onClick}
    onChange={Iprops?.onChange}
    InputProps={{
      endAdornment: (
        <InputAdornment position='end'>
          <CalendarMonthIcon />
        </InputAdornment>
      ),
    }}
    error={Iprops?.error}
    helperText={Iprops?.helperText}
    ref={ref}
  />
));

function NDatePicker(props) {
  return (
    <DatePicker
      className='App-inputs input-datePicker rounded-lg py-5 px-2'
      customInput={
        <DatePickerInput
          value={props?.value}
          InputPlaceholder={props?.placeholder}
          label={props?.label}
          error={props?.error}
          helperText={props?.helperText}
        />
      }
      selected={props?.value}
      onChange={props?.onChange}
      {...props}
    />
  );
}

NDatePicker.propTypes = {
  value: PropType.any,
  label: PropType.string,
  helperText: PropType.string,
  error: PropType.bool,
  placeholder: PropType.string,
  onChange: PropType.func,
};

NDatePicker.defaultProps = {
  value: '',
  placeholder: '',
  helperText: '',
  error: false,
  label: '',
  onChange: () => {},
};

export default NDatePicker;
